module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"PRICE_FORMAT":"{euros},{cents} €","BUY_TICKET":"Ticket kaufen | Tickets kaufen"},"en":{"PRICE_FORMAT":"EUR {euros}.{cents}","BUY_TICKET":"Buy Ticket | Buy Tickets"}}')
  delete Component.options._Ctor
}
